export const stylesServicesOffer = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'grey.100',
};

export const stylesBoxContainer = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  p: 4,
  m: 4,
  backgroundColor: '#FFF',
};
export const stylesBoxContainerTitle = {
  mb: 4,
  fontWeight: '600',
};
export const stylesBoxContainerSubtitle = {
  color: 'primary.main',
  mb: 4,
  fontWeight: '600',
};

export const stylesBoxChoice = {
  flex: 1,
  display: 'flex',
  gap: 4,
  flexWrap: 'wrap',
};

export const stylesBoxChoiceIcon = {
  fontSize: 'bodyXLBold.fontSize',
  mt: 0.25,
  width: '2rem',
  height: '2rem',
};
